import React from "react";
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import * as echarts from "echarts";
import _ from 'lodash';


export const ChartIntensity = (props) => {
    const { jsonData, chartName, chartHeight } = props;
    const { t } = useTranslation();
    const chartRef = React.useRef(null);
    const myChart = React.useRef(null);

    
    React.useEffect(() => {
        if (!myChart.current && chartRef.current) {
            myChart.current = echarts.init(chartRef.current);
        }

        const dataList = [
            { name: t('assessment.low'), value: jsonData?.low ?? 0 },
            { name: t('assessment.medium'), value: jsonData?.medium ?? 0 },
            { name: t('assessment.high'), value: jsonData?.high ?? 0 }
        ];

        const option = {
            tooltip: {
                trigger: 'item'
            },
            legend: {
                top: '0',
                left: 'left',
                orient: 'vertical',
                textStyle: {
                    fontSize: Math.round(myChart.current._dom.offsetWidth) < 400 ? 8 : 12,
                    fontWeight: 'bold'
                }
            },
            series: [{
                name: chartName,
                type: 'pie',
                radius: ['40%', '100%'],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                label: {
                    show: true,
                    position: 'center',
                    fontSize: Math.round(myChart.current._dom.offsetWidth / 18),
                    fontWeight: '800'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: Math.round(myChart.current._dom.offsetWidth / 18),
                        fontWeight: '800'
                    }
                },
                labelLine: {
                    show: false
                },
                data: dataList,
            }]
        };

        if (myChart.current) {
            myChart.current.showLoading();
            myChart.current.setOption(option);
            myChart.current.hideLoading();
        }
        
        
        // 창크기 변경할때 카트를 갱신한다.
        const handleResize = _.debounce(() => {
            if (myChart.current) {
                myChart.current.showLoading();
                myChart.current.setOption(option);
                myChart.current?.resize();
                myChart.current.hideLoading();
            }
        }, 50); // Debounce for 50ms

        window.addEventListener('resize', handleResize);

        return () => {
            try {
                window.removeEventListener('resize', handleResize);
            
                myChart.current && myChart.current.dispose();
                myChart.current && myChart.current.dispose();
                myChart.current = null;
            }
            catch (err) {
                console.log("Unload", new Date().toISOString(), JSON.stringify(err), err);
            }
        };
    }, [jsonData, chartName, chartHeight]);


    return <div ref={chartRef} style={{ width: "100%", height: chartHeight || "100px" }} />;
};

ChartIntensity.propTypes = {
    jsonData: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.func,
        PropTypes.object,
    ]).isRequired,
    chartName: PropTypes.string,
    chartHeight: PropTypes.string,
};
